(function (window, document) {
  'use strict';
  if (window.MilionplusConsent) return;
  var allowed = false;
  var inserted = false;
  var blockedPush = null;
  var privacyPromise = null;
  var bannerPromise = null;
  var layer = window.dataLayer = window.dataLayer || [];

  function consentCommand(mode, granted) {
    var status = granted ? 'granted' : 'denied';
    var command = (function () { return arguments; })('consent', mode, {
      analytics_storage: status, ad_storage: status,
      ad_user_data: status, ad_personalization: status
    });
    (blockedPush || layer.push).call(layer, command);
  }
  consentCommand('default', false);

  function dropEvents() { return layer.length; }
  function blockEvents() {
    if (blockedPush) return;
    blockedPush = layer.push;
    layer.push = dropEvents;
  }
  function unblockEvents() {
    if (!blockedPush) return;
    if (layer.push === dropEvents) layer.push = blockedPush;
    blockedPush = null;
  }
  function syncConsent() {
    var next = false;
    try {
      var api = window.Shopify.customerPrivacy;
      var choice = api.currentVisitorConsent();
      next = choice.analytics === 'yes' && choice.marketing === 'yes' &&
        api.analyticsProcessingAllowed() === true && api.marketingAllowed() === true;
    } catch (_) { /* Missing API fails closed. */ }
    var wasAllowed = allowed;
    allowed = next;
    if (!allowed) {
      if (wasAllowed) consentCommand('update', false);
      if (inserted) blockEvents();
      return;
    }
    unblockEvents();
    if (!wasAllowed) consentCommand('update', true);
    if (inserted) return;
    inserted = true;
    layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WNBB975';
    script.onload = function () {
      // A revoke may occur while the request is in flight. Reapply the block
      // after GTM has installed its dataLayer processor.
      if (!allowed) {
        unblockEvents();
        consentCommand('update', false);
        blockEvents();
      }
    };
    document.head.appendChild(script);
  }

  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve();
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise(function (resolve, reject) {
      var attempts = 0;
      var timeout = window.setTimeout(function () { reject(new Error('Privacy API timeout')); }, 8000);
      function load() {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          if (++attempts < 50) return window.setTimeout(load, 100);
          window.clearTimeout(timeout);
          reject(new Error('Privacy API unavailable'));
          return;
        }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          window.clearTimeout(timeout);
          if (error || !window.Shopify.customerPrivacy) reject(new Error('Privacy API failed'));
          else resolve();
        });
      }
      load();
    }).catch(function (error) { privacyPromise = null; throw error; });
    return privacyPromise;
  }
  function loadBanner() {
    if (window.privacyBanner && window.privacyBanner.showPreferences) return Promise.resolve();
    if (bannerPromise) return bannerPromise;
    bannerPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timeout = window.setTimeout(function () { reject(new Error('Cookie banner timeout')); }, 8000);
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = function () {
        window.clearTimeout(timeout);
        if (window.privacyBanner && window.privacyBanner.showPreferences) resolve();
        else reject(new Error('Cookie banner unavailable'));
      };
      script.onerror = function () { window.clearTimeout(timeout); reject(new Error('Cookie banner failed')); };
      document.head.appendChild(script);
    }).catch(function (error) { bannerPromise = null; throw error; });
    return bannerPromise;
  }
  function showPreferences() {
    return loadPrivacy().then(loadBanner).then(function () {
      return window.privacyBanner.showPreferences();
    });
  }
  window.MilionplusConsent = {
    showPreferences: showPreferences,
    pushEvent: function (event) {
      syncConsent();
      if (!allowed) return false;
      layer.push(event);
      return true;
    }
  };
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cookie-preferences]');
    if (!button) return;
    event.preventDefault();
    showPreferences().catch(function () {
      window.alert(document.documentElement.lang === 'en'
        ? 'Cookie settings could not be loaded. Please try again.'
        : 'Nastavení cookies se nepodařilo načíst. Zkuste to prosím znovu.');
    });
  });
  blockEvents();
  loadPrivacy().then(syncConsent).catch(function () { /* Keep GTM blocked. */ });
})(window, document);
